export const billingAccessRoutes = ["/payments", "/clinic-pet-details"];
export const inventoryAccessRoutes = ["/inventory"];
export const groomerAccessRoutes = ["/groomdashboard", "/groom-pet-details"];
export const labAccessRoutes = ["/labdashboard", "/lab-pet-details"];
export const pharmacyAccessRoutes = [
  "/phramacydashboard",
  "/pharmacy-pet-details",
];

const RESTRICTED_ROLES = new Set([
  "ROLE_BILLING",
  "ROLE_INVENTORY",
  "ROLE_GROOMER",
  "ROLE_RADIOLOGY",
  "ROLE_PHARMACY",
]);

const ROLE_ACCESS_ROUTES = {
  ROLE_BILLING: billingAccessRoutes,
  ROLE_INVENTORY: inventoryAccessRoutes,
  ROLE_GROOMER: groomerAccessRoutes,
  ROLE_RADIOLOGY: labAccessRoutes,
  ROLE_PHARMACY: pharmacyAccessRoutes,
};

const ROLE_DEFAULT_ROUTES = {
  ROLE_BILLING: "/payments",
  ROLE_INVENTORY: "/inventory",
  ROLE_GROOMER: "/groomdashboard",
  ROLE_RADIOLOGY: "/labdashboard",
  ROLE_PHARMACY: "/phramacydashboard",
};

export const parseAllRoles = () => {
  try {
    const stored = localStorage.getItem("allRoles");
    if (!stored) {
      const role = localStorage.getItem("role");
      return role ? [role] : [];
    }
    const parsed = JSON.parse(stored);
    if (Array.isArray(parsed)) return parsed.filter(Boolean);
    return stored ? [stored] : [];
  } catch {
    const stored = localStorage.getItem("allRoles");
    if (stored?.includes(",")) {
      return stored
        .split(",")
        .map((role) => role.trim())
        .filter(Boolean);
    }
    const role = localStorage.getItem("role");
    return stored ? [stored] : role ? [role] : [];
  }
};

export const isPathAllowedForRoles = (path, roles = parseAllRoles()) => {
  if (roles.some((role) => !RESTRICTED_ROLES.has(role))) {
    return true;
  }

  return roles.some((role) => ROLE_ACCESS_ROUTES[role]?.includes(path));
};

export const getDefaultRouteForRoles = (roles = parseAllRoles()) => {
  const primaryRole = localStorage.getItem("role");
  if (primaryRole && ROLE_DEFAULT_ROUTES[primaryRole]) {
    return ROLE_DEFAULT_ROUTES[primaryRole];
  }

  const restrictedRole = roles.find((role) => ROLE_DEFAULT_ROUTES[role]);
  return restrictedRole
    ? ROLE_DEFAULT_ROUTES[restrictedRole]
    : "/dashboard";
};
